// extracted by mini-css-extract-plugin
export default {"wholePageImage":"styles_wholePageImage__sBZIg","image1":"styles_image1__Qr5MR","image2":"styles_image2__yXNXi"};